<template>
  <v-container>
    <v-card class="pa-3 text-xs-left" v-if="item !== undefined">
      <v-layout align-center justify-start row fill-height>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="prevLink" color="primary" icon>
              <v-icon>undo</v-icon>
            </v-btn>
          </template>
          <span>Назад</span>
        </v-tooltip>
        <v-card-title class="display-1 text-xs-left">
          <strong>{{ item.lastName[0].text }} {{ item.firstName[0].text }} <span v-if="item.patronymic !== null">{{ item.patronymic[0].text }}</span></strong>
        </v-card-title>
      </v-layout>
      <v-card-title class="display-1 text-xs-left">
        <strong>{{ item.lastName[1].text }} {{ item.firstName[1].text }} <span v-if="item.patronymic !== null">{{ item.patronymic[1].text }}</span></strong>
      </v-card-title>
      <v-layout wrap>
        <v-flex md12>
          <v-card-text class="subheading text-xs-left pb-0"><strong>Тема диссертационной работы:&nbsp;</strong></v-card-text>
          <v-card-text class="subheading text-xs-left py-0">
            {{ item.thesisTopic[0].text }}
          </v-card-text>
          <v-card-text class="py-0 font-italic subheading text-xs-left">
            {{ item.thesisTopic[1].text }}
          </v-card-text>
          <v-card-title class="subheading pb-0"><strong>Соискатель ученой степени:&nbsp;</strong>
          </v-card-title>
          <v-card-title class="subheading py-0">Соискатель ученой степени
            {{ setAcademicName }}
          </v-card-title>
          <v-card-title class="subheading py-0 font-italic">
            <span v-if="setAcademicName.indexOf('доктор') !==-1">Doctor of Science (Dr.Sc)</span>
            <span v-else>Doctor of Philosophy (Ph.D.)</span>
          </v-card-title>
          <div v-for="item, i in scientificField">
            <v-card-title class="subheading pb-0"><strong>Научная специальность:</strong>
            </v-card-title>
            <v-card-title class="subheading  py-0">
              {{ item.scientificField.scientificSpecialty.code }}
              {{ item.scientificField.scientificSpecialty.name[0].text }}
            </v-card-title>
            <v-card-title class="subheading py-0 font-italic"> {{ item.scientificField.scientificSpecialty.code }}
              {{ item.scientificField.scientificSpecialty.name[1].text }}`
            </v-card-title>

            <v-card-title class="subheading "><strong>Отрасль
              науки:&nbsp;</strong>{{ item.scientificField.scientificIndustry.name[0].text }}
              науки
            </v-card-title>
            <v-card-title class="subheading pt-0"><strong>Branch Of
              Science:&nbsp;</strong>{{ item.scientificField.scientificIndustry.name[1].text }}

            </v-card-title>
          </div>
        </v-flex>
      </v-layout>
      <v-card-title class="subheading pt-0"><strong>Дата проведения защиты (Presentation Date):&nbsp;</strong>
        {{ setDate(item.protectionDate) }}
      </v-card-title>
      <v-card-title class="subheading pt-0"><strong>Место проведения защиты (Place of Presentation of
        Dissertation):&nbsp;</strong> {{ item.location }}
      </v-card-title>
      <v-card-text class="text-xs-left subheading pt-0" v-if="item.thesisPDF!==null">
        <strong>Диссертация (Dissertation):&nbsp;</strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.thesisPDF">Диссертация</a>
      </v-card-text>
      <v-card-text class="text-xs-left subheading pt-0" v-if="item.synopsis!==null">
        <strong>Автореферат (Abstract): </strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.synopsis">Автореферат</a>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="item.annotation!==null">
        <strong>Аннотация (Summary): </strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.annotation">Аннотация</a>
      </v-card-text>
      <v-card-title class="subheading pb-0"><strong>Организация, в которой выполнена работа (Organization where the
        dissertation was completed):&nbsp;</strong>
      </v-card-title>
      <v-card-title class="subheading py-0  ">
        {{ item.organization.name[0].text }}
      </v-card-title>
      <v-card-title class="subheading py-0 font-italic">
        {{ item.organization.name[1].text }}
      </v-card-title>

      <v-card-title class="text-xs-left subheading pb-0" v-if="scientificBoss.length > 0"><strong>Научный
        руководитель:&nbsp;</strong></v-card-title>
      <div v-for="item, i in scientificBoss">
        <v-layout column v-if="item.person">
          <v-card-title class="text-xs-left subheading py-0">
            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>
          </v-card-title>
          <v-card-title class="text-xs-left subheading py-0">
            <span v-if="item.person">{{ setWorker(item.person, 1) }}&nbsp;</span>
          </v-card-title>
        </v-layout>
      </div>

      <v-card-title class="text-xs-left subheading pb-0" v-if="scientificConsultant.length > 0"><strong>Научный
        консультанты(Scientific Consultant):&nbsp;</strong></v-card-title>
      <div v-for="item, i in scientificConsultant">
        <v-layout column>
          <v-card-title class="text-xs-left subheading py-0">
            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>
          </v-card-title>
          <v-card-title class="text-xs-left subheading py-0">
            <span v-if="item.person">{{ setWorker(item.person, 1) }}&nbsp;</span>
          </v-card-title>
        </v-layout>
      </div>

      <v-card-text class="text-xs-left subheading" v-if="item.councilReviewProtocol!==null">
        <strong>Протокол заседания диссертационного совета по приему диссертации к защите: </strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.councilReviewProtocol">Протокол</a>
      </v-card-text>

      <v-card-title class="subheading pb-0" v-if="dataReviewOpp.length > 0">
        <strong>Оппоненты (Opponents):&nbsp;</strong></v-card-title>
      <v-card-text v-if="dataReviewOpp.length > 0" class="py-0">
        <div class="text-xs-left subheading py-0" v-for="item, i in dataReviewOpp">
          <div v-if="item.review !== null">
            <v-layout column>
              <div v-for="n, j in item.opponent.lastName">
                <span v-if="item.opponent">{{ setWorker(item.opponent, j) }}&nbsp;</span>
              </div>
            </v-layout>
          </div>
        </div>
      </v-card-text>

      <div class="text-xs-left subheading pt-0" v-if="dataReviewOrg.length > 0">
        <v-card-title  class="text-xs-left pb-0"><strong>Ведущая организация (Lead Оrganization): </strong></v-card-title>
        <div class="text-xs-left  py-0" v-for="item, i in dataReviewOrg">

          <v-card-title class="text-xs-left subheading py-0" v-if="item.organization">
            {{ item.organization.name[0].text }}
          </v-card-title>
          <v-card-title class="text-xs-left subheading py-0" v-if="item.organization">
            {{ item.organization.name[1].text }}
          </v-card-title>

        </div>
      </div>
      <v-card-title class="subheading " v-if="item.publicationDate !== null"><strong>Дата размещения
        объявления (Date of add placement):&nbsp;</strong> {{ setDate(item.publicationDate) }}
      </v-card-title>

      <v-card-title class="display-1 text-xs-left"> Отзывы</v-card-title>
      <v-card-text class="text-xs-left subheading pt-0" v-if="dataReviewOrg.length > 0">
        <strong>Отзыв ведущей организации (Reviews of Lead Оrganization):&nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewOrg">
          <div v-if="item.review !== null">
            <span v-if="item.organization">{{ item.organization.name[0].text }}</span>
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв ({{ item.reviewType }})</a>
          </div>
        </div>
      </v-card-text>
      <v-card-text class="text-xs-left subheading pt-0" v-if="dataReviewOpp.length > 0">
        <strong>Отзывы оппонентов (Reviews of Оpponents):&nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewOpp">
          <div v-if="item.review !== null">
            <span v-if="item.opponent">{{ setWorker(item.opponent) }}&nbsp;</span>
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв ({{ item.reviewType }})</a>
          </div>
        </div>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="dataReviewPerson.length > 0">
        <strong>Отзывы на диссертацию (Reviews For The Dissertation):&nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewPerson">
          <div v-if="item.review !== null">

            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>

            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв ({{ item.reviewType }})</a>
          </div>
        </div>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="dataReviewPersonAbstract.length > 0">
        <strong>Отзывы на автореферат (Reviews For Abstract)&nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewPersonAbstract">
          <div v-if="item.review !== null">
            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв ({{ item.reviewType }})</a>
          </div>
        </div>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="scientificBoss.length > 0">
        <strong>Отзыв научного руководителя (Supervisor Review): &nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in scientificBoss">
          <div v-if="item.review !== null">
            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв</a>
          </div>
        </div>
      </v-card-text>


      <v-card-text class="text-xs-left subheading pt-0" v-if="scientificConsultant.length > 0">
        <strong>Отзыв научного консультанта:&nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in scientificConsultant">
          <div v-if="item.review !== null">
            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв</a>
          </div>
        </div>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="item.councilProtectionProtocol!==null">
        <strong>Протокол заседания диссертационного совета по защите диссертации</strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.councilProtectionProtocol">Протокол</a>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="item.councilProtectionConclusion!==null">
        <strong>Заключение диссертационного совета по защите</strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.councilProtectionConclusion">Заключение</a>
      </v-card-text>

      <v-card-text class="text-xs-left subheading pt-0" v-if="item.rectorOrder!==null">
        <strong>Приказ о выдаче диплома (Diploma Order)</strong>
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.rectorOrder">Приказ</a>
      </v-card-text>

    </v-card>
  </v-container>
</template>

<script>
import {makeGetRequest} from "../../../helper";
import urls from "../../../modules/petition/urls"
import moment from "moment"

export default {
  name: "DetailAuthor",
  data: function () {
    return {
      item: undefined,
      scientificField: {},
      scientificConsultant: [],
      scientificBoss: [],
      dataReviewPerson: [],
      dataReviewPersonAbstract: [],
      dataReviewOrg: [],
      dataReviewOpp: [],
    }
  },
  created() {
    this.loadData()
  },
  computed: {

    setAcademicName: function () {
      let name = ""
      let title = ""
      if (this.item.academicDegree)
        name = this.item.academicDegree.name[0].text
      let scientificField = "";

      if (Array.isArray(this.scientificField)) {
        scientificField = this.scientificField[0].scientificField.scientificIndustry.name[0].text

        let sp = name.split(' ')
        if (sp.length === 2) {
          title = sp[0].toLowerCase() + "а " + scientificField.toLowerCase().replace("ие", 'их') + " " + sp[1].toLowerCase()
        }
      }
      return title;
    },
  },
  methods: {

    setWorker: function (worker, lang = 0) {

      let academicRank = "";
      let workPlace = "";
      let post = "";
      let scientificIndustry = '';
      let academicDegree = '';

      if (Array.isArray(worker.academicDegree)) {
        if (worker.academicDegree.length > 0)
          if (lang === 0) {
            let sci = "";
            if (worker.academicDegree[0].scientificIndustry)
              sci = worker.academicDegree[0].scientificIndustry.name[lang].text.charAt(0).toLowerCase() + "."
            let aca = "";
            if (worker.academicDegree[0].academicDegree) {
              aca = worker.academicDegree[0].academicDegree.name[lang].text.charAt(0).toLowerCase() + "."
              scientificIndustry = aca + sci + "н., "
            }
          } else
            scientificIndustry = worker.academicDegree[0].academicDegree.name[1].text + ", "
      }
      if (worker.academicRank) {
        academicRank = worker.academicRank.name[lang].text + ", ";
      }
      if (worker.post) {
        post = ", " + worker.post[lang].text + ", ";
      }
      if (worker.workPlace) {
        workPlace = worker.workPlace.name[lang].text + ", ";
      }

      let answ = scientificIndustry + " " +
        academicRank.toLowerCase() + " " +
        worker.lastName[lang].text + " " +
        worker.firstName[lang].text + " " +
        worker.patronymic[lang].text + " " +
        post + " " + workPlace

      return answ
    },

    setDate(date, locale = 'ru') {
      let now = moment(date);
      now.locale(locale);
      return now.format('ll')
    },

    prevLink() {
      this.$router.go(-1)
    },
    loadScientificConsultant() {
      let urlsci = new URL(urls.getUrl(this.item.scientificConsultant.url_name, this.item.scientificConsultant.action))
      let params = this.item.scientificConsultant.get_params
      urlsci.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.scientificConsultant = json.results

        if (this.scientificConsultant.length > 0) {
          for (let i in this.scientificConsultant) {
            let obj = this.scientificConsultant[i].person
            let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
            urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
            this.loadAcademicDegreePerson(urlsci, this.scientificConsultant[i].person)
          }
        }

      })
    },

    loadReview(url, str, params) {

      url.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})
        if (str !== 'dataReviewPerson')
          this[str] = json.results

        if (this.dataReviewOpp.length > 0) {
          for (let i in this.dataReviewOpp) {
            try {
              let obj = this.dataReviewOpp[i].opponent
              let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
              urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
              this.loadAcademicDegreePerson(urlsci, this.dataReviewOpp[i].opponent)
            } catch (err) {
              console.log(err)
              // обработка ошибки

            }
          }
        }

        if (str === 'dataReviewPerson') {
          let data = json.results
          for (let i in data) {
            if (data[i].reviewType === 'Диссертация') {
              this['dataReviewPerson'].push(data[i])
            } else {
              this['dataReviewPersonAbstract'].push(data[i])
            }
          }

          if (this.dataReviewPerson.length > 0) {
            for (let i in this.dataReviewPerson) {
              try {
              let obj = this.dataReviewPerson[i].person
              let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
              urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
              this.loadAcademicDegreePerson(urlsci, this.dataReviewPerson[i].person)
              } catch (err) {
                console.log(err)
                // обработка ошибки

              }
            }
          }

          if (this.dataReviewPersonAbstract.length > 0) {
            for (let i in this.dataReviewPersonAbstract) {
              try {

              let obj = this.dataReviewPersonAbstract[i].person
              let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
              urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
              this.loadAcademicDegreePerson(urlsci, this.dataReviewPersonAbstract[i].person)
              } catch (err) {
                console.log(err)
                // обработка ошибки

              }
            }
          }

        }
      })
    },
    loadScientificBoss() {
      let urlsci = new URL(urls.getUrl('public|case|models|scientific_boss-list', 'list'))
      let params = this.item.scientificBoss.get_params
      urlsci.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})
        this.scientificBoss = json.results
        if (this.scientificBoss.length > 0) {
          for (let i in this.scientificBoss) {
            let obj = this.scientificBoss[i].person
            let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))

            urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
            this.loadAcademicDegreePerson(urlsci, this.scientificBoss[i].person)
          }
        }
      })
    },

    loadScientificField() {
      let urlsci = new URL(urls.getUrl(this.item.scientificField.url_name, this.item.scientificField.action))
      let params = this.item.scientificField.get_params
      urlsci.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.scientificField = json.results
      })
    },

    loadAcademicDegreePerson(urlsci, obj) {
        let sys = true
        makeGetRequest(urlsci).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          if (!sys)
            this.$router.push({name: 'PageNotFound'})
          obj.academicDegree = json
        })

    },

    loadData() {
      this.loading = true
      let url = process.env.VUE_APP_API_HOST + "council/public/case/models/candidate_case/" + this.$route.params.uid + "/"
      if (this.$route.params.uid === undefined)
        this.$router.push({name: 'PageNotFound'})
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.item = json
        if (this.item.scientificField !== undefined)
          this.loadScientificField()
        if (this.item.scientificConsultant !== undefined)
          this.loadScientificConsultant()
        if (this.item.scientificBoss !== undefined)
          this.loadScientificBoss()

        let urlper = new URL(urls.getUrl('public|case|models|review_person-list', 'list'))
        let params = this.item.scientificField.get_params
        params.page_size = "100";
        this.loadReview(urlper, 'dataReviewPerson', params)
        let urlorg = new URL(urls.getUrl('public|case|models|review_organization-list', 'list'))
        this.loadReview(urlorg, 'dataReviewOrg', params)
        let urlopp = new URL(urls.getUrl('public|case|models|review_opponent-list', 'list'))
        this.loadReview(urlopp, 'dataReviewOpp', params)


        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
